<template>
    <section class="mt-16">
      <v-breadcrumbs
          v-if="this.$root.$vuetify.theme.isDark"
          large
          :items="crumbs"
          divider="/"
          light
          :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
        ></v-breadcrumbs>
        <v-breadcrumbs
          v-else
          :items="crumbs"
          divider="/"
          light
          :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
        ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-hard-hat</v-icon> <span>{{$t('indirect_work_hand.crumb_add')}}</span>
        </h1>
  
        <div class="mt-16" :style="this.$root.$vuetify.theme.isDark ? '' : 'background-color: rgba(255, 255, 255, 0.75) !important;'">
          <IndirectWorkHand method="create"></IndirectWorkHand>
        </div>
    </section>
  </template>
  <script>
  import IndirectWorkHand from '@/components/indirectWorkHand/IndirectWorkHand'
  
  export default {
    components: {
      IndirectWorkHand
    },
    beforeCreate(){
      document.title = "Report Lake - " + this.$t('indirect_work_hand.crumb_add');
    },
    data: () => ({
      
    }),
    mounted(){
  
      if(!this.$root.session.hasPermission(["super", "indirect_work_hand.create"])) {
        this.$router.push('/admin');
      }
  
    },
    methods:{
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: this.$t('menu.dashboard'),
            disabled: false,
            to: '/' + this.$session.get('domain') + '/admin',
            exact: true,
          },
          {
            text: this.$t('menu.material_management'),
            disabled: false,
            to: '/' + this.$session.get('domain') + '/admin/budgeting/indirect_work_hand',
            exact: true,
          },
          {
            text: this.$t('indirect_work_hand.crumb_add'),
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  